/**
 * 묶음 CL1(2차 평론 — 첫 방문 글꼴 1.24MB) — **게임 안 글꼴은 입장할 때 받는다.**
 *
 * 첫 화면은 그 화면 글자만 담은 부분집합(index.html first-fonts 구역 — `tools/gen-first-fonts.mjs`)을 받고, 원본 세 벌(Galmuri11 보통·굵게,
 * Galmuri14)은 부분집합에 없는 글자가 화면에 올 때까지 받지 않는다. 게임 안 글(채팅·이름·창·캔버스 글자)은 거의 다 부분집합 밖이라
 * 입장을 시작하는 순간(main.js `enter()`) 원본을 받기 시작한다 — 입장 판이 덮는 동안 도착해, 판이 걷힐 때 대체 글꼴로 그린 글이 없게.
 * 받는 동안은 `document.fonts.status` 가 'loading' 이라 GPU 몸 글자는 캔버스 경로로 그리고(scene.js) 글자 폭 기억은 도착하면 비운다
 * (text-width-cache.js) — 전부터 있던 늦은 글꼴 처리 그대로다.
 *
 * 부분집합 면(unicode-range 가 좁은 면)은 건드리지 않는다. 같은 이름의 원본 면(범위 전체)만 부른다. 한 번만.
 */
let started = false;
const FAMILY = /^["']?Galmuri1[14]["']?$/;

/** 원본 면을 받기 시작한다. 부른 면 수를 돌려준다(이미 시작했거나 글꼴 API 가 없으면 0) */
export function loadGameFonts(fonts = globalThis.document?.fonts) {
  if (started || !fonts) return 0;
  started = true;
  let n = 0;
  try {
    for (const face of fonts) {
      if (!FAMILY.test(face.family) || face.status !== 'unloaded') continue;
      const range = String(face.unicodeRange || 'U+0-10FFFF').toUpperCase().replace(/\s/g, '');
      if (range !== 'U+0-10FFFF') continue;   // 첫 화면 부분집합 면
      n++;
      face.load().catch(() => { /* 못 받으면 대체 글꼴 — 첫 화면과 같은 열린 실패 */ });
    }
  } catch { /* 글꼴 목록을 못 돌면 화면이 글자를 만날 때 받는다 */ }
  return n;
}
